import React, { useState, useEffect } from "react";
import { GetData } from "../../services/api";
import { useParams, useNavigate } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Badge
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import Loader from "../../components/Common/Loader";
import moment from "moment";

const CampaignDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [campaign, setCampaign] = useState(null);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [campaignData, statsData] = await Promise.all([
          GetData(`/campaigns/${id}`),
          GetData(`/campaigns/${id}/stats`)
        ]);
        setCampaign(campaignData.data);
        setStats(statsData.data);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching campaign:", err);
        setLoading(false);
      }
    };
    fetchData();
  }, [id]);

  if (loading) {
    return (
      <Loader size={150} />
    );
  }

  if (!campaign) {
    return <div>Campaña no encontrada</div>;
  }

  const getStatusBadge = (status) => {
    const statusMap = {
      draft: { color: "secondary", text: "Borrador" },
      scheduled: { color: "info", text: "Programada" },
      sending: { color: "warning", text: "Enviando" },
      sent: { color: "success", text: "Enviada" },
      cancelled: { color: "danger", text: "Cancelada" },
    };
    const statusInfo = statusMap[status] || { color: "secondary", text: status };
    return <Badge color={statusInfo.color}>{statusInfo.text}</Badge>;
  };

  return (
    <div className="page-content">
      <Container fluid={true}>
        <Breadcrumbs 
          title="IHubG" 
          breadcrumbItem={
            <>
              <span onClick={() => navigate("/campaigns")} style={{cursor: "pointer"}}>Campañas</span> / {campaign.name}
            </>
          } 
        />
        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <Row className="mb-3">
                  <Col>
                    <h4>{campaign.name}</h4>
                    {getStatusBadge(campaign.status)}
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <p><strong>Tipo:</strong> {campaign.type}</p>
                    <p><strong>Asunto:</strong> {campaign.subject || "-"}</p>
                    <p><strong>Creada:</strong> {moment(campaign.createdAt).format("DD/MM/YYYY HH:mm")}</p>
                    {campaign.scheduledAt && (
                      <p><strong>Programada:</strong> {moment(campaign.scheduledAt).format("DD/MM/YYYY HH:mm")}</p>
                    )}
                  </Col>
                  <Col md={6}>
                    {stats && (
                      <>
                        <h5>Estadísticas</h5>
                        <p><strong>Enviados:</strong> {stats.sentCount}</p>
                        <p><strong>Abiertos:</strong> {stats.openedCount} ({stats.openRate?.toFixed(2)}%)</p>
                        <p><strong>Clickeados:</strong> {stats.clickedCount} ({stats.clickRate?.toFixed(2)}%)</p>
                      </>
                    )}
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CampaignDetails;

